/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Serve_TitleInputs */

const en_serve_title = /** @type {(inputs: Serve_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My computer`)
};

const id_serve_title = /** @type {(inputs: Serve_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komputer saya`)
};

/**
* | output |
* | --- |
* | "My computer" |
*
* @param {Serve_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const serve_title = /** @type {((inputs?: Serve_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Serve_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_serve_title(inputs)
	return en_serve_title(inputs)
});